var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24,2.4171,21.5829,0,12,9.5829,2.4171,0,0,2.4171,9.5829,12,0,21.5829,2.4171,24,12,14.4171,21.5829,24,24,21.5829,14.4171,12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearAlt);
export default __webpack_public_path__ + "static/media/clear-alt.cf20906242b2972347d1f184922a8106.svg";
export { ForwardRef as ReactComponent };